import { Person } from "schema-dts";

import { schemaOrgOrganizations } from "./organization";

export const HUBERTUS_SCHERBARTH_SCHEMA_AWARDS = [
  "Handelsblatt Ones to Watch 2026 - Gesellschaftsrecht",
  "Handelsblatt Ones to Watch 2026 - Steuerrecht",
] as const;

enum SolvingLegalPersons {
  ScherbarthHubertus = "ScherbarthHubertus",
}

export const schemaOrgPersons: Partial<Record<SolvingLegalPersons, Person>> = {
  [SolvingLegalPersons.ScherbarthHubertus]: {
    "@type": "Person",
    additionalName:
      "Rechtsanwalt/Steuerberater Hubertus Scherbarth,LL.M., B.A.",
    name: "Hubertus Scherbarth",
    honorificPrefix: "Rechtsanwalt/Steuerberater",
    honorificSuffix: "LL.M., B.A.",
    jobTitle: "CEO",
    award: [...HUBERTUS_SCHERBARTH_SCHEMA_AWARDS],
    memberOf: schemaOrgOrganizations.SolvingLegal,
    nationality: "DE",
    worksFor: schemaOrgOrganizations.SolvingLegal,
  },
};
